// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
/*
Example of calling the component from 'paymentTerminalUnbindingPresenter.jsx':

...
import EndpointsTestingComponent from './endpointsTestingComponent'
...

    <EndpointsTestingComponent
        paymentTerminalUnbinding={paymentTerminalUnbinding}
        onPaymentTerminalUnbindingPost={onPaymentTerminalUnbindingPost}
        onPaymentTerminalUnbindingClear={onPaymentTerminalUnbindingClear}
        {...props}
    />

*/
    export default
        function EndpointsTestingComponent(
        {
            paymentTerminalUnbinding, // fetch result of '/Proxy/PaymentTerminalUnbinding',
            // //------------------------------------------
            onPaymentTerminalUnbindingPost, // fetch '/Proxy/PaymentTerminalUnbinding',
            // //------------------------------------------
            onPaymentTerminalUnbindingClear,
            // //------------------------------------------
            ...props
        }
        )
        {
            const [authTokenpaymentTerminalUnbinding, setAuthTokenpaymentTerminalUnbinding] = React.useState('')
            const [phoneNumberpaymentTerminalUnbinding, setPhoneNumberpaymentTerminalUnbinding] = React.useState('')
            const [merchantTerminalIDpaymentTerminalUnbinding, setMerchantTerminalIDpaymentTerminalUnbinding] = React.useState('')
            React.useEffect(() => {
                const str =
                    paymentTerminalUnbinding === null || paymentTerminalUnbinding === undefined
                    ? ""
                    : JSON.stringify(paymentTerminalUnbinding, undefined, 2);

                document.getElementById("paymentTerminalUnbindingJsonId").innerHTML = str;
            }, [paymentTerminalUnbinding])
            function listReferenceRender() {
                return (
                    <div className='container-lg'>
                        <a
                            href='current#'
                            onClick={(event) => {
                                event.preventDefault();
                                props.history.push('/endpoint-testing-list');
                            }}
                        >
                            testing components list
                        </a>
                    </div>
                )
            }
            function proxyPaymentTerminalUnbindingPaymentTerminalUnbindingTestingForm() {
                return (
                    <>
                        <hr/>
                        <hr/>
                        <fieldset className='container-lg'>
                            <legend>Input values for endpoint '<span style={{color: 'blue'}}>/api/Proxy/PaymentTerminalUnbinding'</span></legend>
                            <p><span><b>Отвязать платёжный терминал от устройства</b></span></p>
                            <p><span><b>Server call</b></span></p>
                            <form className='form-group' onReset={()=>onPaymentTerminalUnbindingClear()} onSubmit={event => {
                                event.preventDefault()
                                if (!authTokenpaymentTerminalUnbinding) {
                                    alert("'AuthToken' is required.")
                                    return
                                }
                                if (!phoneNumberpaymentTerminalUnbinding) {
                                    alert("'PhoneNumber' is required.")
                                    return
                                }
                                if (!merchantTerminalIDpaymentTerminalUnbinding) {
                                    alert("'MerchantTerminalID' is required.")
                                    return
                                }
                                onPaymentTerminalUnbindingPost({authToken: authTokenpaymentTerminalUnbinding, phoneNumber: phoneNumberpaymentTerminalUnbinding, merchantTerminalID: merchantTerminalIDpaymentTerminalUnbinding})
                            }}>
                            <div style={{marginTop: 8}} className='card'>
                                <div className='card-body'>
                                    <p style={{marginTop: 10}}><b>Body object properties (InputView properties):</b></p>
                                        <div style={{marginTop: 16}}>
                                            <div  style={{marginTop: 0}}>
                                                <label htmlFor='authTokenpaymentTerminalUnbindingId' className='form-label'>AuthToken</label>
                                                <input type='text' id='authTokenpaymentTerminalUnbindingId' className='form-control' value={authTokenpaymentTerminalUnbinding} onChange={event => setAuthTokenpaymentTerminalUnbinding(event.target.value)}/>
                                                {!authTokenpaymentTerminalUnbinding && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'AuthToken' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='phoneNumberpaymentTerminalUnbindingId' className='form-label'>PhoneNumber</label>
                                                <input type='text' id='phoneNumberpaymentTerminalUnbindingId' className='form-control' value={phoneNumberpaymentTerminalUnbinding} onChange={event => setPhoneNumberpaymentTerminalUnbinding(event.target.value)}/>
                                                {!phoneNumberpaymentTerminalUnbinding && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'PhoneNumber' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='merchantTerminalIDpaymentTerminalUnbindingId' className='form-label'>MerchantTerminalID</label>
                                                <input type='text' id='merchantTerminalIDpaymentTerminalUnbindingId' className='form-control' value={merchantTerminalIDpaymentTerminalUnbinding} onChange={event => setMerchantTerminalIDpaymentTerminalUnbinding(event.target.value)}/>
                                                {!merchantTerminalIDpaymentTerminalUnbinding && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'MerchantTerminalID' is required.
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    <input className='btn btn-primary' style={{marginTop: 24}} type = 'submit' value = 'Submit'/>
                                    <input className='btn' style={{marginTop: 24, marginLeft: 16}} type = 'reset' value = 'Clear'/>
                                </div>
                            </div>
                            </form>
                        </fieldset>
                        {proxyPaymentTerminalUnbindingPaymentTerminalUnbindingTestingResult()}
                    </>
                )
            }
            function proxyPaymentTerminalUnbindingPaymentTerminalUnbindingTestingResult() {
                return (
                    <>
                        <div style={{marginTop: 32}} className='container-lg'>
                            <p><b>Result of endpoint '<span style={{color: 'navy'}}>/api/Proxy/PaymentTerminalUnbinding</span>':</b></p>
                            <span>{'--> HttpResultDto paymentTerminalUnbinding'}</span>
                            <pre id="paymentTerminalUnbindingJsonId"></pre>
                        </div>
                    </>
                )
            }
            return (
                <>
                    {listReferenceRender()}
                    {proxyPaymentTerminalUnbindingPaymentTerminalUnbindingTestingForm()}
                </>
            )
        }
